import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { Sites } from '@enums/sites';
import { environment } from '@environments/environment';
import { ConsultationRequestService } from '@services/consultation-request.service';
import { StdConsultationRequestService } from '@services/std-consultation-request.service';
import { TreatmentConsultationRequestService } from '@services/treatment-consultation-request.service';

const consultationServiceFactory = () => {
  switch (environment.site) {
    default:
    case Sites.Stdcheck:
    case Sites.Healthlabs:
      return isConsultationStdPreventionUrl()
        ? inject(TreatmentConsultationRequestService)
        : inject(StdConsultationRequestService);

    case Sites.Treatmyuti:
    case Sites.Starfish:
    case Sites.Stallion:
    case Sites.TestosteroneHq:
      return inject(TreatmentConsultationRequestService);
  }
};

const isConsultationStdPreventionUrl = (): boolean => {
  const document = inject<Document>(DOCUMENT);

  return document.location.pathname.includes('consultation/std-prevention/request');
};

export const ConsultationRequestServiceProvider = {
  provide: ConsultationRequestService,
  useFactory: consultationServiceFactory,
};
